import { getGPUTier } from "detect-gpu";

export default async function detectGPU() {
  const gpuTier = await getGPUTier();

  if (gpuTier.type !== "WEBGL_UNSUPPORTED") document.documentElement.classList.add("hardware-accelerated");
}
